<template>
    <v-dialog v-if="space" v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="black" dark dense>
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{space.name}}</v-toolbar-title>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>
            <span>Приміщення</span>
            <v-spacer/>
            <button>Edit</button>
          </v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Назва:</v-list-item-title>
              <v-list-item-subtitle>{{space.name}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Площа:</v-list-item-title>
              <v-list-item-subtitle>{{space.total_square}} м<sup>2</sup> <span v-if="space.workplaces">(робочих місць: {{space.workplaces}})</span></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Вартість аренди за м<sup>2</sup> (з ПДВ):</v-list-item-title>
              <v-list-item-subtitle>{{space.subrental_price}} &#8372;</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader v-if="space.latest_rent_history">
          <v-subheader v-if="space.latest_rent_history.tenant">Арендатор</v-subheader>
          <v-list-item v-if="space.latest_rent_history.tenant">
            <v-list-item-content>
              <v-list-item-title>Назва організації:</v-list-item-title>
              <v-list-item-subtitle><span v-if="space.latest_rent_history.tenant.org_type">{{space.latest_rent_history.tenant.org_type.shorten_name}} </span>{{space.latest_rent_history.tenant.name}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item  v-if="space.latest_rent_history.tenant.info">
            <v-list-item-content>
              <v-list-item-title>Інфо:</v-list-item-title>
              <v-list-item-subtitle class="preformatted">{{space.latest_rent_history.tenant.info}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="space.latest_rent_history.contract">
            <v-list-item-content>
              <v-list-item-title>Договор із ним:</v-list-item-title>
              <v-list-item-subtitle>В аренді з {{space.latest_rent_history.contract.rent_started}} по <span v-if="space.latest_rent_history.contract.rent_ended">{{space.latest_rent_history.contract.rent_ended}}</span><span v-else>тепер</span> <span v-if="space.latest_rent_history.contract.auto_prolongation">(з автопролонгацією)</span><span v-else>(без автопролонгації)</span></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'SpaceDetails',
  data() {
    return {
      dialog: this.space !== null || false,
    };
  },
  props: ['space', 'clear'],
  watch: {
    space() {
      this.dialog = this.space !== null;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      if(typeof this.clear === 'function'){
        this.clear();
      }
    }
  }
}
</script>

<style scoped>
.preformatted{
  display: block !important;
  white-space: pre !important;
}
</style>